import { ContextDTO } from '../../../src_server/entity/dto/ContextDTO';


import { GeneratedBizBase } from '../GeneratedBizBase';


import { Response } from '../../../src_server/response/Response';export class ContextDataService extends GeneratedBizBase{
  async getContextData(user_id: string): Promise<Response<ContextDTO>> {
    return super.restCall<Response<ContextDTO>>('get', '/v1/ContextDataService/getContextData', arguments);
  }
  async setIsSetOffcialLineAt(user_id: string,isSet: boolean): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/ContextDataService/setIsSetOffcialLineAt', arguments);
  }
}
